<span class="p-float-label">
	@if (icon && !focus && !model.value) {
		<div class="icon-container">
			<i [class]="icon"></i>
		</div>
	}

	<p-calendar [ngModel]="model.value" (ngModelChange)="onChangeHandler($event)" (onFocus)="onInputFocus($event)"
		(onBlur)="onInputBlur($event)" [required]="required" [inputId]="name" [readonlyInput]="true"
		view="month" dateFormat="mm.yy" [showIcon]="showIcon" [showButtonBar]="showButtonBar"
		[minDate]="minDate" [maxDate]="maxDate">
	</p-calendar>

	<label [for]="name">
		{{ label }}
	</label>

</span>
